import { readController } from 'fc-controller'

import {
  URL,
  MODEL,
} from 'fc-model-seasons'

import {
  TREE,
  BRANCH,
} from 'fc-seasons'

// Selectors
import token$ from 'fc-auth/src/selectors/token'

import composeFetchSaga from 'fc-fetch-worker/src/sagas/composeFetchSaga'

import worker from 'fc-wrkr-seasons'

export default readController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  watch: false,
  initialize: function initialize (controller: Object): Promise<Object> {
    const terminate = function terminate () {
      if (worker) {
        worker.terminate()
      }
    }

    return new Promise((resolve: Function) => {
      terminate()

      resolve({
        terminate,
        handleFetch: composeFetchSaga({
          getWorker: function (): Worker {
            return worker.getWorker()
          },
        }),
      })
    })
  },
})
